import * as React from "react";
import { useTracking } from "@xingternal/crate-communication-tracking";
const PageViewTracker = ({
  trackingChannel,
  pageName
}) => {
  const { track } = useTracking();
  React.useEffect(() => {
    if (trackingChannel && pageName) {
      track({
        type: "pageview",
        channel: trackingChannel,
        page: pageName
      });
    }
  }, [pageName, trackingChannel]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null);
};
export {
  PageViewTracker
};
